<template>
  <div style="height: 400px">
    <canvas ref="chart"></canvas>
  </div>
</template>
<script>
import Chart from 'chart.js';
import { uniq } from 'lodash';
import Colors from '@/utils/colors';

export default {
  name: 'GrowthChart',

  data() {
    return {
      loading: false
    };
  },

  methods: {
    mountChart(payments = []) {
      this.laoding = true;
      const monthFormat = 'MMM/YY';
      payments.forEach(payment => {
        payment.month = this.$moment(payment.date_of_payment).format(
          monthFormat
        );
      });

      const labels = uniq(payments.map(p => p.month));

      const data = [];
      labels.forEach(label => {
        const paymentsMonth = payments.filter(p => p.month == label);
        data.push(paymentsMonth.length);
      });

      const chartDate = {
        type: 'bar',
        data: {
          labels: labels,
          datasets: [
            {
              backgroundColor: Colors.pallet(labels.length),
              label: 'Qtd. Pagamentos.',
              data: data
            }
          ]
        },
        options: {
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          scales: {
            y: {
              beginAtZero: true
            }
          }
        }
      };

      const canvas = this.$refs.chart;
      new Chart(canvas, chartDate);
      this.laoding = false;
    }
  }
};
</script>
<style lang="css" scoped>
canvas {
  height: 400px;
}
</style>
